<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
      <div class="bodyCenter">
        <div class="modalStyle">
          <b-row class="titulo">
            <b-col class="seccionTitulo">
              <span class="fa fa-table"></span>
              <span>Reporte de precios de tratamientos</span>
            </b-col>
            <b-col class="seccionCodigo">
              <div>RP_04</div>
            </b-col>
          </b-row>

          <b-tabs content-class="mt-3" fill>
            <div class="flxDivs">
              <div>
                <b-tabs content-class="mt-3" fill>
                  <b-tab title="Precios de tratamientos por zona" active>
                    <reportePreciosTratamiento />
                  </b-tab>
                  <b-tab title="Precios de tratamientos especiales">
                    <reportePreciosEspecialesTratamientos />
                  </b-tab>
                </b-tabs></div>
            </div>

          </b-tabs>
        </div>
      </div>
  </div>
</template>

<script>
import Header from "../../components/Header";


import reportePreciosTratamiento from "./reportePreciosTratamiento";
import reportePreciosEspecialesTratamientos from "./reportePreciosEspecialesTratamientos";

export default {
  name: "Tratamientos",
  props: {
    msg: String,
  },
  components: {
    Header,
    reportePreciosTratamiento,
    reportePreciosEspecialesTratamientos,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

  }),

  methods: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>
